import React from 'react'
import '../ChatBubble/ChatBubble.css'
import './ChatLoader.css'

const ChatLoader = () => {
    return (
        <div className={'chat-bubble-wrapper'}>
            <div className={`chat-bubble assistant-bubble`}>
                <div className="loader">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                </div>
            </div>
        </div>
    )
}

export default ChatLoader;